import { useQuery } from 'react-query';
import getRequestInvitationDays from '../requests/getRequestInvitationDays';
import { queryKeys } from './queryKeys';

const useRequestInvitationDays = (requestId, options = {}, errMsg) =>
  useQuery(
    queryKeys.requestInvitationDays(requestId),
    () => getRequestInvitationDays(requestId, errMsg),
    options
  );

export default useRequestInvitationDays;
